var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventsBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.131,
    height: 35.329,
    viewBox: "0 0 34.131 35.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2808",
    "data-name": "Grupo 2808",
    transform: "translate(-34.898 -658.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2801",
    "data-name": "Grupo 2801",
    transform: "translate(-18.251 283.079)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1384",
    "data-name": "Ret\\xE2ngulo 1384",
    width: 34.131,
    height: 35.329,
    rx: 10,
    transform: "translate(53.149 375.057)",
    fill: "#b895ff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_broken_book-saved",
    "data-name": "vuesax/broken/book-saved",
    transform: "translate(-66 414.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-saved",
    transform: "translate(108 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,1.635A1.611,1.611,0,0,1,1.768.006a15.355,15.355,0,0,1,5.78,1.916l.2.123a.907.907,0,0,0,.868,0l.139-.09a12.623,12.623,0,0,1,1.883-.925V4.37L12.28,3.281,13.917,4.37V.1a6.353,6.353,0,0,1,.63-.082H14.6a1.613,1.613,0,0,1,1.776,1.629v9.881a1.682,1.682,0,0,1-1.424,1.621l-.27.033a20.843,20.843,0,0,0-6.107,2.014.884.884,0,0,1-.786,0l-.033-.016a21.033,21.033,0,0,0-6.091-2l-.237-.033A1.682,1.682,0,0,1,0,11.524V5.065",
    transform: "translate(1.637 2.18)",
    fill: "none",
    stroke: "#b895ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0V12.28",
    transform: "translate(9.824 4.494)",
    fill: "none",
    stroke: "#b895ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M3.275,0V4.273L1.637,3.184,0,4.273V.933A16.546,16.546,0,0,1,3.275,0Z",
    transform: "translate(12.28 2.276)",
    fill: "none",
    stroke: "#b895ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H19.647V19.647H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsBackground);
export default __webpack_public_path__ + "static/media/eventsBackground.9929b4a5fbdd8d7976a37d268503ef23.svg";
export { ForwardRef as ReactComponent };